// Converts a regular string to hex
export function hexString(input: string): string {
  return Array.from(input)
    .map(char => char.charCodeAt(0).toString(16).padStart(2, '0'))
    .join("");
}

// Converts a hex string back to the original string
export function unHexString(hex: string): string {
  let output = '';
  for (let i = 0; i < hex.length; i += 2) {
    const chunk = hex.substring(i, i + 2);
    output += String.fromCharCode(parseInt(chunk, 16));
  }
  return output;
}

// Generates the final URL
export function generateHexUrl(input: string): string {
  return `/show-all-results?in=${hexString(input)}`;
}
